import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SearchResultsComponent } from 'shared/search/search-results/search-results.component';


@Component({
  moduleId: module.id,
  selector: 'import-manager-search-results',
  templateUrl: 'import-manager-search-results.component.html',
  styleUrls: ['import-manager-search-results.component.scss']
})
export class ImportManagerSearchResultsComponent extends SearchResultsComponent {
  @Output() viewReportClick: EventEmitter<any> = new EventEmitter();

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onViewReportClick(row: any) {
    this.viewReportClick.emit(row);
  }
}
